import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/core/app.state";
import * as OrdersActions from './orders.actions'
import { catchError, finalize, map, mergeMap, of, switchMap, tap } from "rxjs";
import { APIResponse } from "src/app/core/models/api-response";
import { OrdersService } from "../services/orders.services";
import { IOrder, IOrdersKPIs } from "../models/order.model";

@Injectable()
export class OrdersEffects {
  constructor(
    private actions$: Actions,
    public store: Store<AppState>,
    private ordersService: OrdersService,
  ) { }

    // fetch All Orders
    FetchAllOrdersEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrdersActions.GetOrders),
        tap(() => {
          this.store.dispatch(OrdersActions.SetOrdersLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          this.ordersService.getOrders(action.page, action.filter, action.key, action.sort_by, action.sort_mode).pipe(
            map((res: APIResponse<IOrdersKPIs>) => OrdersActions.GetOrdersSuccess({ res })),
            catchError(() => of(
              OrdersActions.GetOrdersError()
            )),
            finalize(() => {
              this.store.dispatch(OrdersActions.SetOrdersLoader({ isLoading: false }));
            }),
          )
        ),
      )
    );

    // export
    exportOrders$ = createEffect(() =>
      this.actions$.pipe(
        ofType(OrdersActions.exportOrders),
        mergeMap((action) =>
          this.ordersService.exportOrders(action.filter, action.key).pipe(
            map((file) => {
              const fileURL = window.URL.createObjectURL(file);
              const link = document.createElement('a');
              link.href = fileURL;
              link.download = `Orders-${new Date().toLocaleString()}.xlsx`;
              link.click();
              return OrdersActions.exportOrdersSuccess({ file });
            }),
            catchError((error) =>
              of(OrdersActions.exportOrdersFailure({ error }))
            )
          )
        )
      )
    );
}
